import { OVERVIEW_ZOOM_THRESHOLD } from '@/app/constants';
import { getAllHeaders, getDefaultConfig } from '.';
import type { LayerConfig } from './types';
import { LayerType } from './types';
import type { GroupId } from '@/features/types';
import { MVTLayer } from '@deck.gl/geo-layers';

const PLACEHOLDER_GREY: [number, number, number, number] = [255, 255, 255, 120];

export const getLineLayer = (
  config: LayerConfig,
  user: string = '',
  zoom: number,
  groupId: GroupId | null = null,
  activeGroupName: string | null = null,
  spanNetworkGroupId: GroupId | null = null,
  mapNetworkGroupId: GroupId | null,
  minZoom = 15,
  maxZoom = 15
) => {
  const getLineWidth = () => {
    if (zoom > OVERVIEW_ZOOM_THRESHOLD) {
      if (!activeGroupName && groupId !== spanNetworkGroupId) {
        return 3;
      } else {
        return 0.1;
      }
    } else {
      return 0;
    }
  };

  if (mapNetworkGroupId) {
    groupId = mapNetworkGroupId;
  }

  const id = LayerType[LayerType.lines];

  const lineWidth = getLineWidth();
  return new MVTLayer({
    ...getDefaultConfig(id, user),
    id,
    ...config,
    loadOptions: {
      fetch: {
        method: 'GET',
        headers: getAllHeaders({ 'Content-Type': 'application/json' }, user),
        credentials: 'include',
      },
    },
    minZoom,
    maxZoom,
    getLineColor: PLACEHOLDER_GREY,
    updateTriggers: {
      getLineColor: [activeGroupName],
    },
    getLineWidth: lineWidth,
    pickable: false,
    lineWidthMaxPixels: 2,
    lineWidthMinPixels: 1,
    filled: false,
  });
};
